import "./App.css";
import * as React from "react";

//MUI
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
// components
import Drawer from "./components/theDrawer";
import AdTestingComponent from "./components/pages/adTestingComponent";
import SeriesImageMaker from "./components/pages/seriesImageMaker";
import FTTestLinks from "./components/pages/ftTestLinks";
import FBCatAds from "./components/pages/facebookCatalogAds";
import FlipAds from "./components/pages/flippAds";
import NLQuery from "./components/pages/nlQuery";
import FBMarkAds from "./components/pages/facebookMarketingAds";
import SeriesAPI from "./components/pages/seriesAPI";
import VastVideo from "./components/pages/vastVideo";
import PHXVastCampaigns from "./components/pages/phxVastCampaigns";
import OATEval from "./components/pages/oatEval";
import BenchmarkAndLeadsProcessing from "./components/pages/benchmarkAndLeadsProcessing";
import ToyotaSalesUploader from "./components/pages/ToyotaSalesUploader";
import NoMode from "./components/pages/noMode";
import RussTestHTML from "./components/pages/russTestHTML";
import InnovidSegments from "./components/pages/innovidSegments";
import DashBoardLinks from "./components/pages/dashBoardLinks";
import { Fab } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ImageServiceTesting from "./components/pages/imageServiceTesting";
import Grid from "@mui/material/Grid";
import { useGoogleLogin } from "@react-oauth/google";
import Button from "@mui/material/Button";

const darkTheme = createTheme({
	palette: {
		mode: "dark"
	}
});

function App() {
	const [theMode, setTheMode] = React.useState(null);
	const [user, setUser] = React.useState(null);

	// setInterval(() => {
	// 	console.log("User:", user);
	// }, 1000);
	const GoogleLoginButton = ({ onLogin }) => {
		const login = useGoogleLogin({
			onSuccess: (tokenResponse) => {
				onLogin(tokenResponse);
			},
			onError: () => alert("Login Failed"),
			scope: "openid email profile"
		});

		return (
			<Button onClick={() => login()} variant="contained">
				Login with Google
			</Button>
		);
	};
	const RegisterButton = () => {
		return (
			<Button
				onClick={() =>
					window.open("https://forms.gle/wvY58oX9Bh7Yt7pA9", "_blank")
				}
				variant="contained"
			>
				Register
			</Button>
		);
	};
	const fetchUserInfo = async (accessToken) => {
		const res = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
			headers: {
				Authorization: `Bearer ${accessToken}`
			}
		});

		const profile = await res.json();

		const allowedEmails = process.env.REACT_APP_USERS.split(",");

		if (!allowedEmails.includes(profile.email)) {
			alert(`Unauthorized user: ${profile.email}`);
			return null;
		}

		// ✅ Store in localStorage
		localStorage.setItem("user", JSON.stringify(profile));
		localStorage.setItem("token", accessToken);
		//sucess in login save this to the mongodb collection logins
		//located mongodb+srv://tcaadev-db-user:QlzsaaQ4WAaqj9zT@tcaadev-com.h69hghh.mongodb.net/?retryWrites=true&w=majority&appName=TCAADev-com

		return profile;
	};
	function connectToAtlas() {}
	React.useEffect(() => {
		connectToAtlas();
		const storedUser = localStorage.getItem("user");
		const storedToken = localStorage.getItem("token");

		if (storedUser && storedToken) {
			setUser(JSON.parse(storedUser));
		}

		const urlParams = new URLSearchParams(window.location.search);
		const mode = urlParams.get("mode");
		setTheMode(mode);
		// if (mode) {
		// 	setTheMode(mode);
		// }
	}, []);

	const getMode = (data) => {
		console.log("getMode: " + data);
		setTheMode(data);
	};
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth"
		});
	};

	return (
		<ThemeProvider theme={darkTheme}>
			<CssBaseline />
			{user ? (
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<div className="App">
							<Grid item xs={6} md={12}></Grid>
							<Drawer theMode={theMode} getMode={getMode} open={!theMode} />
							{theMode == "adtesting" ? (
								<AdTestingComponent mode="adtesting" />
							) : null}
							{theMode == "OATEval" ? <OATEval mode="OATEval" /> : null}
							{theMode == "seriesimagemaker" ? (
								<SeriesImageMaker mode="seriesimagemaker" />
							) : null}

							{theMode == "fttestlinks" ? (
								<FTTestLinks mode="fttestlinks" />
							) : null}
							{theMode == "flipp" ? <FlipAds mode="flipp" /> : null}
							{theMode == "aiplatform" ? (
								<ToyotaSalesUploader mode="aiplatform" />
							) : null}
							{theMode == "dashboards" ? (
								<DashBoardLinks mode="dashboards" />
							) : null}
							{theMode == "fbcatads" ? <FBCatAds mode="FBCatAds" /> : null}
							{theMode == "benchmarkandleadsprocessing" ? (
								<BenchmarkAndLeadsProcessing mode="benchmarkandleadsprocessing" />
							) : null}
							{theMode == "fbmarkads" ? <FBMarkAds mode="FBMarkAds" /> : null}
							{theMode == "toyotasalesuploader" ? (
								<ToyotaSalesUploader mode="toyotasalesuploader" />
							) : null}
							{theMode == "vastvideo" ? <VastVideo mode="VastVideos" /> : null}
							{theMode == "seriesapi" ? <SeriesAPI mode="SeriesAPI" /> : null}
							{theMode == "phxvastcampaigns" ? (
								<PHXVastCampaigns mode="PHXVastCampaigns" />
							) : null}
							{theMode == "imageservicetesting" ? (
								<ImageServiceTesting mode="ImageServiceTesting" />
							) : null}
							{theMode == "nlquery" ? <NLQuery mode="nlquery" /> : null}

							{theMode == "innovidsegments" ? (
								<InnovidSegments mode="innovidsegments" />
							) : null}

							{!theMode ? <NoMode></NoMode> : null}

							<Fab
								color="primary"
								aria-label="scroll back to top"
								onClick={scrollToTop}
								style={{ position: "fixed", bottom: 16, right: 16 }}
							>
								<KeyboardArrowUpIcon />
							</Fab>
						</div>
					</Grid>
				</Grid>
			) : (
				<div className="App">
					<h1>Please log in to continue</h1>
					<GoogleLoginButton
						onLogin={(token) => {
							fetchUserInfo(token.access_token).then((profile) => {
								if (profile) {
									setUser(profile);
								}
							});
						}}
					/>
					<div style={{ marginTop: "40px", marginBottom: "20px" }}>
						If you are not been a registered user please submit a request
					</div>
					<RegisterButton />
				</div>
			)}
		</ThemeProvider>
	);
}

export default App;
